import { Injectable } from '@angular/core';

import { NavigationService, UserService } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

import { ApiService } from '../api/api.service';
import { CommonClientConfig } from '../client-config/client-config.models';
import { ValidationCheckResponse } from '../modular-forms/models/resource-models';
import { PortalNavigationService } from '../services/portal-navigation.service';
import { CommonMethodsService } from '../tracking/common-methods-service';
import { ContactInitDataResponse } from './contact.models';

@Injectable({ providedIn: 'root' })
export class ContactResourceService {
    navigationSourceList: string[] = ['documentpload', 'email', 'mohinterceptor', 'lostPasswordSuccessScreen'];
    navigationSource: any;
    constructor(
        private api: ApiService,
        private commonConfig: CommonClientConfig,
        private commonMethodsService: CommonMethodsService,
        private navigationService: NavigationService,
        private user: UserService,
        private portalNavigation: PortalNavigationService,
    ) {}

    getInitValues(): Observable<ContactInitDataResponse> {
        return this.api.get('contact/getInitContent');
    }

    getPostLoginRedirectOverrideContidionUsnj() {
        return this.api.get('contact/GetPostLoginRedirectOverrideContidionUsnj');
    }

    getFaqItems(data: any) {
        return this.api.get('contact/getfaqitems', data);
    }

    getContactOptionsContent() {
        return this.api.get('contact/getContactOptionsContent', this.commonConfig.enableLoadingV2 ? { showSpinner: false } : { showSpinner: true });
    }
    getSubCategoryContent(data: any) {
        return this.api.get('contact/getSubCategoryContent', data);
    }

    submit(data: any) {
        return this.api.post('contact', data);
    }
    postHelpAndContactData(data: any) {
        return this.api.post('contact/postHelpAndContactData', data);
    }
    checkEmail(email: string): Observable<ValidationCheckResponse> {
        return this.api.get('Registration/CheckEmailAddress', { emailAddress: email });
    }
    updateEmail(data: string | null) {
        return this.api.get('contact/UpdateEmail', { email: data });
    }
    triggerEmailVerification() {
        return this.api.post('accountstatus/ResendEmailVerificationCode');
    }
    guideRouteValidation() {
        this.navigationSource = this.navigationService.location.search.get('source') ? this.navigationService.location.search.get('source') : '';
        const playerPriority = this.user.isAuthenticated && this.user.playerPriority ? this.user.playerPriority : 0;
        if (
            playerPriority == '4' ||
            this.commonMethodsService.getGuideConfig()?.landingPage['p' + playerPriority]?.toLowerCase() == 'contactoptionsscreen' ||
            this.navigationService.location.search.has('z-showoptions') ||
            (this.navigationService.location.search.get('source') && this.navigationSourceList.includes(this.navigationSource)) ||
            this.commonMethodsService.getGuideConfig().showContactOptionsBySource[this.navigationSource] ||
            (this.navigationSource === 'complaintform' && this.commonMethodsService.getGuideConfig().enableGreeceComplaintForm) ||
            (this.navigationService.location.search.get('showContact') == 'true' && this.navigationService.location.search.has('keyword'))
        ) {
            return true;
        } else if (this.commonMethodsService.getGuideConfig().guideEnabled) {
            const category = this.navigationService?.location?.pathname?.split('/').pop() || '';
            const route = this.portalNavigation.normalizeUrl('/guide') + (category ? '?z-category=' + category : '');
            this.navigationService.goTo(route);
            return false;
        } else return true;
    }
}
